import { createApp } from "vue"; // Correct import for Vue 3
import { createRouter, createWebHistory } from "vue-router"; // Correct import for Vue Router in Vue 3
import App from "./App.vue";
import BelgianWaffles from "./components/BelgianWaffles.vue";
import HelloWorld from "./components/HelloWorld.vue";

const routes = [
  // add main path just for App component
  //if there is no path specified, go to /pizza
  { path: "/", redirect: "/pizza" },
  { path: "/waffles", component: BelgianWaffles },
  { path: "/pizza", component: HelloWorld },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

createApp(App).use(router).mount("#app");
